import { paymentMethodDefaultApi } from 'constants/AppConstants';
import { logError } from 'utils/logger.utils';

// #genai Phase 2 — PUT set a saved payment method as the default for the next checkout.
// Empty request body; success 200 returns { type, id, isDefault: true }.
const setPaymentMethodDefault = async ({ type, id }) => {
  try {
    const response = await fetch(paymentMethodDefaultApi(type, id), {
      headers: { 'Content-Type': 'application/json' },
      method: 'PUT',
    });
    const json = await response.json().catch(() => null);
    // #genai Accept any 2xx (response.ok), not only 200 — a non-200 success (e.g. 204) was being
    // treated as a failure, which triggered the optimistic set-default rollback in the reducer so
    // the DEFAULT badge appeared not to move even though the PUT succeeded.
    if (!response.ok) return { ok: false, status: response.status, json };
    return { ok: true, status: response.status, json };
  } catch (error) {
    logError('setPaymentMethodDefault failed', error);
    return { ok: false, status: 0, json: { errorDescription: 'Internal Server Error' } };
  }
};

export default setPaymentMethodDefault;
